import { render, staticRenderFns } from "./investment-account-transfer.component.vue?vue&type=template&id=53af4d1a&"
import script from "./investment-account-transfer.component.vue?vue&type=script&lang=ts&"
export * from "./investment-account-transfer.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports